"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
function ReplacementMecanism(node) {
    return (jsx_runtime_1.jsxs("span", { children: ["Remplace ", jsx_runtime_1.jsx(Explanation_1.default, { node: node.replacedReference }, void 0), ' ', node.rawNode.par && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: ["par ", jsx_runtime_1.jsx(Explanation_1.default, { node: node.replacementNode }, void 0)] }, void 0)), node.rawNode.dans && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: ["dans", ' ', node.whiteListedNames
                        .map((child, i) => jsx_runtime_1.jsx(Explanation_1.default, { node: child }, i))
                        .join(', ')] }, void 0)), node.rawNode['sauf dans'] && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: ["sauf dans", ' ', node.blackListedNames
                        .map((child, i) => jsx_runtime_1.jsx(Explanation_1.default, { node: child }, i))
                        .join(', ')] }, void 0))] }, void 0));
}
exports.default = ReplacementMecanism;
